import { render, staticRenderFns } from "./ParcourscliniqueEdit.vue?vue&type=template&id=be0298ce&"
import script from "./ParcourscliniqueEdit.vue?vue&type=script&lang=js&"
export * from "./ParcourscliniqueEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports